import { apiFetchCouponList, apiFetchMutiCouponList } from '@/api/imee'

export const mixin = {
  data () {
    return {
      // 优惠券popup
      popActive: 0,
      showCoupon: false,
      // 切换标题
      tebTit: [
        {
          id: 0,
          tit0: this.$t('lang.intimate.valid'),
        },
        {
          id: 1,
          tit1: this.$t('lang.intimate.expired'),
        },
      ],
      validCouponList: [], // 有效的优惠券
      validCouponListSort: [], // 降序排序过的优惠券
      expiredCouponList: [], // 过期的优惠券
      maxCoupon: {},

      showResultDia: false, // 返回支付页面提示支付结果弹窗
      payResultText: '',
      scene: this.$route.query.scene || null, //判断是哪个页面 如果是活动页面 scene = activity 则不显示优惠券入口，也不调接口

      googlePayClickText: '', //点击谷歌支付传过来的文案


      // 支付的价格设置固定的宽度
      // 定义的常量
      paysChannelMaxWhith: {
        PIX: '78', //巴西
        PAPARA: '81', //土耳其
        Vodafone: '90', //埃及
        MADA: '82', //沙特阿拉伯
        SPEI: '60', //墨西哥
        Chek: '70', //智利
        NEQUI: '75', //哥伦比亚
      },
      // 已有的支付方式
      havePayChannel: [],
    }
  },

  created () {
    if (this.scene != 'activity') {
      // 请求优惠劵列表（有效+无效）
      this.fetchMutiCouponList()
    }
  },

  mounted () {
    window.onNewIntent = this.onNewIntent
  },

  //计算属性
  computed: {
    longestWidth () {
      return Math.max(...this.havePayChannel.map((item) => item.width))
    },
  },

  methods: {
    // 获取shopType
    // prettier-ignore
    getShopType () {
      // 路由参数无
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },
    // 给客户端调用 传回来参数
    onNewIntent (url) {
      if (url) {
        let data = JSON.parse(url)
        if (data.status == "PENDING") {
          this.payResultText = this.$t('lang.pay.resultPidding')
          this.showResultDia = true
        }
        if (data.status == "FAILED") {
          this.payResultText = this.$t('lang.pay.resultFailed')
          this.showResultDia = true
        }
        if (data.status == "CLOSED") {
          this.payResultText = 'Closed'
          this.showResultDia = true
        }
      }
    },

    // 复制链接
    copyWeb (id) {
      let createInput = document.createElement('input')
      createInput.value = link
      document.body.appendChild(createInput)
      createInput.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      createInput.style.display = 'none'
    },

    // pay 优惠劵 相关的函数
    // 获取优惠劵 优惠券状态 0-待使用 1-使用锁定 2-已使用 3-已过期
    fetchCouponList (val) {
      let parmas = {
        state: val,
      }
      apiFetchCouponList(parmas).then((res) => {
        if (res) {
          if (parmas.state == 0) {
            this.validCouponList = res
          }
          if (parmas.state == 3) {
            this.expiredCouponList = res
          }
        }
      })
    },
    // 获取优惠券-多参数
    fetchMutiCouponList (val) {
      apiFetchMutiCouponList({}).then((resData) => {
        if (resData) {
          // 有效的
          this.validCouponList = resData.validCouponRecords || []
          // 过期的
          this.expiredCouponList = resData.invalidCouponRecords || []
        }
      })
    },
    // 找最优的优惠券
    fatchMaxCoupon (item, couponList) {
      let list = null
      if (couponList) {
        list = couponList
      } else {
        list = this.validCouponList
      }
      if (item) {
        let arr = list.filter((option) => {
          return option.minUseAmount <= item.amount
        })
        // 从大到小
        this.validCouponListSort = arr.sort((a, b) => b.amount - a.amount)
        this.maxCoupon = this.validCouponListSort[0] || null
      }
    },

    // 确定选中的优惠卷,把优惠券信息传过来
    confirmChooseCouponId (option) {
      if (Object.keys(option).length > 0) {
        this.maxCoupon = option
      } else {
        this.maxCoupon = this.validCouponListSort[0] || null
      }
      this.closePop(false)
    },

    // 打开优惠券列表
    openCouponPop () {
      this.fetchCouponList(0)
      this.showCoupon = true
    },

    // 关闭优惠劵pop
    closePop (val) {
      this.showCoupon = val
    },

    // 处理数据 找到已有的支付方式 返回宽度
    processData (arr) {
      this.havePayChannel = arr.map((key) => {
        return {
          label: key.name,
          width: this.paysChannelMaxWhith[key.name] || 90,
        }
      })
    },
  }
}
